export class Carousel {
	init() {
		const carousels = document.querySelectorAll<HTMLElement>(".carousel");

		carousels.forEach(carousel => {
			const previousButton = carousel.parentElement?.querySelector(
				".carousel ~ .previous"
			);
			const nextButton =
				carousel.parentElement?.querySelector(".carousel ~ .next");
			const numberOfElements = carousel.children.length;
			const countElement =
				carousel.parentElement?.querySelector<HTMLElement>(".count");

			const numberOfVisibleElements = () => {
				return parseInt(
					getComputedStyle(carousel).getPropertyValue("--num-of-columns")
				);
			};

			if (countElement) {
				const currentOffset = parseInt(
					carousel.style.getPropertyValue("--data-offset")
				);
				countElement.innerText = `${currentOffset + 1}/${numberOfElements}`;
			}

			previousButton?.addEventListener("click", () => {
				const currentOffset = parseInt(
					carousel.style.getPropertyValue("--data-offset")
				);
				let endOffset = currentOffset - 1;

				if (currentOffset <= 0) {
					endOffset = Math.ceil(numberOfElements / numberOfVisibleElements() - 1);
				} else if (endOffset >= numberOfElements / numberOfVisibleElements()) {
					endOffset = numberOfElements / numberOfVisibleElements() - 1;
				}

				carousel.style.setProperty(
					"--data-offset",
					Math.floor(endOffset).toString()
				);
				if (countElement) {
					countElement.innerText = `${
						Math.floor(endOffset) + 1
					}/${numberOfElements}`;
				}
			});

			nextButton?.addEventListener("click", () => {
				const currentOffset = parseInt(
					carousel.style.getPropertyValue("--data-offset")
				);
				let endOffset = currentOffset + 1;
				const maxEndOffset = Math.ceil(
					numberOfElements / numberOfVisibleElements()
				);

				if (endOffset >= maxEndOffset) {
					endOffset = 0;
				}

				carousel.style.setProperty("--data-offset", endOffset.toString());
				if (countElement) {
					countElement.innerText = `${endOffset + 1}/${numberOfElements}`;
				}
			});
		});

		window.addEventListener("resize", () => {
			carousels.forEach(carousel => {
				carousel.style.setProperty("--data-offset", "0");
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const banners = new Carousel();
	banners.init();
});
